<template>
  <div class="ai-slider">
    <div class="track-wrap">
      <div class="fill" :style="{ width: pct + '%' }"></div>
      <input type="range" :min="min" :max="max" :step="step"
             :value="value" @input="$emit('input', +$event.target.value)" />
      <span class="bubble" :style="{ left: pct + '%' }">{{ display }}</span>
    </div>
    <div class="ends"><span>{{ minLabel }}</span><span>{{ maxLabel }}</span></div>
  </div>
</template>

<script>
export default {
  name: 'AiSlider',
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 1 },
    step: { type: Number, default: 0.01 },
    minLabel: { type: String, default: '' },
    maxLabel: { type: String, default: '' },
    // formats the bubble, e.g. v => Math.round(v*100)+'%'
    format: { type: Function, default: null },
  },
  computed: {
    pct() { return ((this.value - this.min) / (this.max - this.min)) * 100; },
    display() { return this.format ? this.format(this.value) : this.value; },
  },
};
</script>

<style scoped>
.ai-slider { padding-top: 26px; }
.track-wrap { position: relative; height: 8px; }
.track-wrap::before {
  content: ''; position: absolute; inset: 0; border-radius: 999px; background: #e2e8f0;
}
.fill {
  position: absolute; top: 0; left: 0; height: 8px; border-radius: 999px;
  background: linear-gradient(90deg, #60a5fa, #2563eb);
}
input[type=range] {
  position: absolute; inset: -6px 0; width: 100%; height: 20px;
  margin: 0; background: none; -webkit-appearance: none; appearance: none; cursor: pointer;
}
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none; appearance: none; width: 20px; height: 20px; border-radius: 50%;
  background: #fff; border: 3px solid #2563eb; box-shadow: 0 1px 4px rgba(0,0,0,.25); margin-top: 0;
}
input[type=range]::-moz-range-thumb {
  width: 20px; height: 20px; border-radius: 50%; background: #fff;
  border: 3px solid #2563eb; box-shadow: 0 1px 4px rgba(0,0,0,.25);
}
.bubble {
  position: absolute; top: -26px; transform: translateX(-50%);
  background: #1e293b; color: #fff; font-size: 11px; font-weight: 700;
  padding: 2px 8px; border-radius: 6px; white-space: nowrap;
}
.bubble::after {
  content: ''; position: absolute; left: 50%; bottom: -4px; transform: translateX(-50%);
  border: 4px solid transparent; border-top-color: #1e293b;
}
.ends { display: flex; justify-content: space-between; font-size: 10.5px; color: #94a3b8; margin-top: 6px; }
</style>
